<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-sm-12 pl-3 pr-3 pb-4">
        <div v-if="resultList && resultList.length > 0" class="col-12 d-flex justify-content-end mb-2">
            <button
                class="btn btn-sm btn-success form-button"
                @click.stop="showAll()"
            >
                {{ $t('trip.show_map') }}
            </button>
            <button
                class="btn btn-sm btn-outline-success form-button"
                @click.stop="exportToExcel()"
            >
                {{ $t('common.download_excel') }}
            </button>
        </div>
        <Transition name="fade">
            <div v-if="resultList && resultList.length > 0" class="col-sm-12 list-content result-table">
                <vue3-datatable
                    :rows="resultList"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :height="resultList.length > 7 ? '55vh' : '100%'"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                >
                    <template #vehicle="data">
                        <span v-if="data.value.vehicle" class="nopads">
                            {{ data.value.vehicle.license_plate }} {{ data.value.vehicle.make }} {{ data.value.vehicle.vehicle_model }}
                        </span>
                    </template>
                    <template #spreader_system="data">
                        {{ getSystemName(data.value.spreader_system) }}
                    </template>
                    <template #contract="data">
                        <span v-if="data.value.contract">{{ data.value.contract.name }}</span>
                    </template>
                    <template #info="data">
                        {{ errorCodeConverter(data.value.info) }}
                    </template>

                    <template #map="data">
                        <div class="spreader-data-actions">
                            <div class="nopads" @click.stop="emitEdit(data.value.id)">
                                <font-awesome-icon
                                    :id="'map'+data.value.id"
                                    icon="map"
                                    class="row-icon"
                                    style="color: #4AAE9B"
                                    :title="$t('spreader_data.show_map')"
                                />
                            </div>
                            <div class="nopads" @click.stop="emitEdit(data.value.id, true)">
                                <font-awesome-icon
                                    :id="'export'+data.value.id"
                                    icon="cloud-upload-alt"
                                    class="row-icon"
                                    :class="{ failed: data.value.export_status === 2, success: data.value.export_status === 1, unknown: !data.value.export_status}"
                                    :title="$t('spreader_data.export')"
                                />
                            </div>
                            <div v-if="data.value.export_status === 1" class="nopads" @click.stop="emitRemove(data.value)">
                                <font-awesome-icon
                                    :id="'remove'+data.value.id"
                                    icon="plug"
                                    class="row-icon row-plug-icon"
                                    :title="$t('spreader_data.remove_external')"
                                />
                            </div>
                        </div>
                    </template>
                </vue3-datatable>
            </div>
        </Transition>
    </div>
</template>

<script>
import {workManagementHelper} from '../../mixins/WorkManagementMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import {vehicleHelper} from "@/components/mixins/VehicleMixin";
import {spreaderDataMixin} from "@/components/mixins/SpreaderDataMixin";
import {utility} from '@/components/mixins/Utils'
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'SpreaderDataList',
    mixins: [timeUtils, workManagementHelper, vehicleHelper, spreaderDataMixin, utility],
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'tasktype',
            sortDesc: false,
            fields: [
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'time', title: this.$t('spreader_data.time'), sort: true, headerClass: 'routa-table-header', minWidth: '15em'},
                {field: 'contract', title: this.$t('orders.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle', title: this.$t('trip_list.vehicle'), sort: true, headerClass: 'routa-table-header'},
                {field: 'spreader_system', title: this.$t('spreader_data.spreader_system'), sort: true, headerClass: 'routa-table-header'},
                {field: 'spreader_id', title: this.$t('spreader_data.spreader'), sort: true, headerClass: 'routa-table-header'},
                {field: 'dry_material', title: this.$t('spreader_data.dry_material'), sort: true, headerClass: 'routa-table-header'},
                {field: 'dose_dry', title: this.$t('spreader_data.spreading_dose_dry'), sort: true, headerClass: 'routa-table-header'},
                {field: 'dry_amount', title: this.$t('spreader_data.dry_amount'), sort: true, headerClass: 'routa-table-header'},
                {field: 'liquid_material', title: this.$t('spreader_data.liquid_material'), sort: true, headerClass: 'routa-table-header'},
                {field: 'dose_liquid', title: this.$t('spreader_data.spreading_dose_liquid'), sort: true, headerClass: 'routa-table-header'},
                {field: 'liquid_amount', title: this.$t('spreader_data.liquid_amount'), sort: true, headerClass: 'routa-table-header'},
                {field: 'liquid_dry_material_mass', title: this.$t('spreader_data.liquid_dry_material_mass'), sort: true, headerClass: 'routa-table-header'},
                {field: 'info', title: this.$t('common.info'), sort: true, headerClass: 'routa-table-header', minWidth: '25em'},
                {field: 'map', title: '', sort: false, headerClass: 'routa-table-header'}
            ],
            resultList: [],
            loading: false
        }
    },
    watch: {
        results() {
            let temp = [];
            this.resultList = [];

            this.results.forEach(item => {
                let newItem = {...item};

                // Assign values for dry material
                newItem.dry_material = item.material_dry ? this.getMaterialName(item.material_dry) : '';
                newItem.dry_amount = item.total_dry_amount ? item.total_dry_amount.toFixed(1) + item.material_dry_unit : '0';
                newItem.dose_dry = (item.dose_dry ? item.dose_dry : '-') + ' ' + item.dose_dry_unit

                // Assign values for liquid material
                newItem.liquid_material = item.material_liquid ? this.getMaterialName(item.material_liquid) : '';
                newItem.liquid_dry_material_mass = item.liquid_dry_material_mass ? item.liquid_dry_material_mass.toFixed(1) + ' kg' : '0';
                newItem.liquid_amount = item.total_liquid_amount ? item.total_liquid_amount.toFixed(1) + item.material_liquid_unit : '0 ' + item.material_liquid_unit;
                newItem.dose_liquid = (item.dose_liquid ? item.dose_liquid : '-') + ' ' + item.dose_liquid_unit

                // Format time
                newItem.time = `${this.toLocalTime(item.start_time)} - ${this.toLocalTime(item.end_time)}`;

                temp.push(newItem);
            });

            this.$nextTick(() => {
                this.resultList = temp;
            });
        }

    },
    methods: {
        getSystemName(system) {
            if(this.spreaderSystems.SYSTEM_FLEET === system) {
                return this.$t('spreader_data.system_fleet')
            }
            if(this.spreaderSystems.SYSTEM_AM === system) {
                return this.$t('spreader_data.system_am')
            }
            if(this.spreaderSystems.SYSTEM_ROUTA === system) {
                return this.$t('spreader_data.system_routa')
            }

            return system
        },
        emitEdit: function (result, openHarjaSender = false) {
            let item = this.results.find(item => result === item.id)
            if (item) {
                this.$emit('rowSelected', item, openHarjaSender)
            }
        },
        emitRemove(itemId) {
            // TODO - Show modal confirmation dialog about removing data from 3rd party service
            this.$emit('removeItem', itemId)
        },
        showAll() {
            this.$emit('showAll')
        },
        exportToExcel() {
            this.$emit('exportToExcel')
        },
    }
}
</script>
<style scoped>
.spreader-data-actions {
    display: flex;
    gap: 1rem;
    padding-left: .5em;
}

.failed {
    color: #9e0c0c;
}

.failed:hover {
    color: #770707;
}


.success {
    color: #7FC000;
}

.success:hover {
    color: #5a8602;
}

.unknown {
    color: #007BFF;
}

.unknown:hover {
    color: #0b4b8f;
}
</style>
